var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50065 1.5835C5.13857 1.5835 1.58398 5.13808 1.58398 9.50016C1.58398 13.8622 5.13857 17.4168 9.50065 17.4168C13.8627 17.4168 17.4173 13.8622 17.4173 9.50016C17.4173 5.13808 13.8627 1.5835 9.50065 1.5835ZM12.9444 12.3264C12.8336 12.5164 12.6357 12.6193 12.4298 12.6193C12.3269 12.6193 12.224 12.5956 12.129 12.5322L9.67482 11.0677C9.06523 10.7035 8.61398 9.90391 8.61398 9.19933V5.9535C8.61398 5.62891 8.88315 5.35975 9.20773 5.35975C9.53232 5.35975 9.80148 5.62891 9.80148 5.9535V9.19933C9.80148 9.48433 10.039 9.90391 10.2844 10.0464L12.7386 11.511C13.0236 11.6772 13.1186 12.0414 12.9444 12.3264Z",
    fill: "#656E74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.41ffb7a0e5e83a0311ddb82a4a3802c5.svg";
export { ForwardRef as ReactComponent };